export enum MatchType {
  INCLUDES = 'includes',
  EXACT = 'exact'
}

export type ConfigPattern = {
  matchType: MatchType
  value: string
}

export const configPatterns: readonly ConfigPattern[] = [
  { matchType: MatchType.EXACT, value: '/infinite' },
  { matchType: MatchType.EXACT, value: '/broke-landing-page' },
  { matchType: MatchType.EXACT, value: '/elite' },
  { matchType: MatchType.EXACT, value: '/elite/:variant' },
  { matchType: MatchType.EXACT, value: '/elite-dashboard' },
  { matchType: MatchType.EXACT, value: '/elite-x-fd' },
  { matchType: MatchType.EXACT, value: '/elite-family' }
]

/**
 * Usage guide:
 * - Keep all route rules in `configPatterns`.
 * - Use `MatchType.EXACT` for route-pattern matching (supports static routes and
 *   param routes like `/mutual-fund/:isin`).
 * - Use `MatchType.INCLUDES` for substring checks when multiple related paths
 *   should share the same loader background.
 */
export function shouldUseBlackWaveLoaderBackground(pathname: string): boolean {
  if (!pathname) return false
  return isBlackWaveLoaderBackgroundPathname(pathname)
}

/*
========================================
HELPER FUNCTIONS
========================================
*/
export function matchesRoutePattern(pathname: string, pattern: string): boolean {
  const pathnameSegments = pathname?.split('/')?.filter(Boolean)
  const configPatternSegments = pattern?.split('/')?.filter(Boolean)

  if (pathnameSegments?.length !== configPatternSegments?.length) return false

  return configPatternSegments?.every((configPatternSegment, index) => {
    const pathnameSegment = pathnameSegments?.[index] ?? ''
    if (configPatternSegment?.startsWith(':')) return Boolean(pathnameSegment)
    return configPatternSegment === pathnameSegment
  })
}

export function isBlackWaveLoaderBackgroundPathname(pathname: string): boolean {
  return configPatterns?.some((patternConfig) => {
    if (patternConfig?.matchType === MatchType.INCLUDES) {
      return pathname?.includes(patternConfig?.value ?? '')
    }
    return matchesRoutePattern(pathname, patternConfig?.value ?? '')
  })
}
